interface Routes {
  home: string;
}

export const routes: Routes = {
  home: '/'
};
